import { useState } from "react";

import { Alert, AlertProps } from "@mantine/core";

import { IconExclamationCircle } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

interface LabsOrderInactiveAlertProps extends AlertProps {}

export default function LabsOrderInactiveAlert({ ...props }: LabsOrderInactiveAlertProps) {
  const [isClosed, setIsClosed] = useState(false);

  return (
    <Alert
      radius="sm"
      color="yellow"
      withCloseButton
      hidden={isClosed}
      title="Activate Lab Integration"
      onClose={() => setIsClosed(true)}
      styles={{ title: { fontSize: "var(--mantine-font-size-md)" } }}
      icon={<IconExclamationCircle size={16} color="var(--mantine-color-orange-8)" />}
      {...props}
    >
      <TextWrapper mt="xs">
        Please contact support to begin the lab integration setup. You can continue with Manual
        Result Entry and Upload Results by clicking Actions.
      </TextWrapper>
    </Alert>
  );
}
